import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import en from "./locales/en"
import pl from "./locales/pl"
import legacy from "./locales/legacy"
import { LEGACY_LANGUAGE } from "./language"

// All bundles are bundled statically: they are small next to the main chunk,
// and a Polish user must not see an English flash while a bundle loads.
i18n.use(initReactI18next).init({
  lng: LEGACY_LANGUAGE,
  fallbackLng: "en",
  // Without this, "pl-ZZ" would also load the full "pl" bundle.
  load: "currentOnly",
  resources: {
    en: { translation: en },
    pl: { translation: pl },
    [LEGACY_LANGUAGE]: { translation: legacy },
  },
  // React already escapes; i18next escaping would show "A&B" as "A&amp;B".
  interpolation: { escapeValue: false },
  initImmediate: false,
  returnNull: false,
})

export default i18n
